import API from "../api";
import * as routes from './routes';
import {TokenStorage} from '../tokenStorage';

export function fetchTickets(options = {}) {
    return API.get(routes.FETCH_TICKETS, { ...TokenStorage.getAuthentication(), params : options})
        .then(response => ({ response }))
        .catch(error => ({ error }));
}

export function fetchTicketTabs(ticketID) {
    return API.get(routes.TICKET_TABS + ticketID, { ...TokenStorage.getAuthentication()})
        .then(response => ({ response }))
        .catch(error => ({ error }));
}

export function fetchTicketSummary(ticketID) {
    return API.get(routes.TICKET_SUMMARY + ticketID, { ...TokenStorage.getAuthentication()})
        .then(response => ({ response }))
        .catch(error => ({ error }));
}

export function fetchTicketAttachments(ticketID) {
    return API.get(routes.FETCH_ATTACHMENTS + ticketID, { ...TokenStorage.getAuthentication()})
        .then(response => ({ response }))
        .catch(error => ({ error }));
}

export function fetchTicketDevices(ticketID) {
    return API.get(routes.FETCH_DEVICES + ticketID, { ...TokenStorage.getAuthentication()})
        .then(response => ({ response }))
        .catch(error => ({ error }));
}

export function fetchTicketCustomFields(ticketID) {
    return API.get(routes.FETCH_CUSTOM_FIELDS + ticketID, { ...TokenStorage.getAuthentication()})
        .then(response => ({ response }))
        .catch(error => ({ error }));
}

export function fetchTicketComments(ticketID, options = {}) {
    return API.get(routes.FETCH_COMMENTS + ticketID, { ...TokenStorage.getAuthentication(), params : options})
        .then(response => ({ response }))
        .catch(error => ({ error }));
}

export function fetchTicketComment(hash) {
    return API.get(routes.FETCH_TICKET_COMMENT + hash, { ...TokenStorage.getAuthentication()})
        .then(response => ({ response }))
        .catch(error => ({ error }));
}

export function fetchTicketRelated(ticketID, options = {}) {
    return API.get(routes.FETCH_RELATED + ticketID, { ...TokenStorage.getAuthentication(), params : options})
        .then(response => ({ response }))
        .catch(error => ({ error }));
}

export function fetchTicketOperations(ticketID, options = {}) {
    return API.get(routes.FETCH_OPERATIONS + ticketID, { ...TokenStorage.getAuthentication(), params : options})
        .then(response => ({ response }))
        .catch(error => ({ error }));
}

export function takeOverTicket(ticketID, forceTakeover = 0) {
    return API.post(routes.TAKE_OVER_TICKET, {ticket_id : ticketID, force_takeover : parseInt(forceTakeover)}, { ...TokenStorage.getAuthentication()})
        .then(response => ({ response }))
        .catch(error => ({ error }));
}

export function postTicketComment(bodyFormData) {
    return API({
        method: 'post',
        url: routes.POST_TICKET_COMMENT,
        data: bodyFormData,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    });
}

export function createQuickTicket(data) {
    return API.post(routes.POST_QUICK_TICKET, data, { ...TokenStorage.getAuthentication()})
        .then(response => ({ response }))
        .catch(error => ({ error }));
}

/* FILTERS */
export function fetchQuickFilters() {
    return API.get(routes.FETCH_QUICK_FILTERS, { ...TokenStorage.getAuthentication()})
        .then(response => ({ response }))
        .catch(error => ({ error }));
}
